import React, { useContext, useMemo, useRef } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';
/**
 * Atoms
 */
import { Listbox } from '../../lab/Listbox';
import RadioButtonGroup from '../../elements/RadioButtonGroup';
import { useIsMobileView } from '@front10/utils';
import Box from '../../elements/Box';
import Text from '../../elements/Text';
/**
 * Hooks
 */

const TravelClassFilter = (props, ref) => {
  const {
    options = [
      { label: 'cmp-travel-class--economy', value: 'ECONOMY' },
      { label: 'cmp-travel-class--business', value: 'BUSINESS' }
    ],
    value,
    labelKey = 'cmp-travel-class-label',
    disabled,
    onChange,
    showTitle,
    filterButtonIconProps,
    containerSettings = {
      showSeparator: true,
      enabledDoneButton: true,
      isMobile: false
    },
    showDescriptionLabel = false,
    disabledActiveFilterButtonValue = undefined,
    mobileOrientation = 'horizontal', // horizontal or vertical
    containerStyle,
    titleStyle = {
      fontWeight: 'bold'
    },
    itemsContainerStyle = {},
    itemsStyles = {}
  } = props;

  const {
    translate,
    direction,
    theme: { designTokens }
  } = useContext(Context);

  let isMobile = useIsMobileView();
  if (containerSettings.isMobile) {
    isMobile = containerSettings.isMobile;
  }

  const title = translate('cmp-travel-class-title', 'Travel Class');
  const travelClassOptions = useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option) => ({
      ...option,
      label: translate(option.label)
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translate, options]);

  const listboxRef = useRef(null);
  const [travelClassValue, setTravelClass] = React.useState(value[0]);

  React.useEffect(() => {
    setTravelClass(value[0]);
  }, [value]);

  React.useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        listboxRef.current?.focusToggleElement();
      }
    }),
    []
  );

  const desktopLayout = (
    <Listbox
      filterButtonIconProps={filterButtonIconProps}
      activeFilterButton={
        disabledActiveFilterButtonValue ? disabledActiveFilterButtonValue !== value[0] : undefined
      }
      ref={listboxRef}
      label={translate(labelKey, 'Select Travel Class')}
      placeholder={title}
      options={travelClassOptions}
      defaultValue={Array.isArray(value) ? value[0] : value}
      forcePlaceholder={disabled}
      disabled={disabled}
      onChange={(value) => onChange({ value })}
      focusWhenIsShow={false}
      prefixSelectedItem={
        showDescriptionLabel
          ? translate('cmp-travel-class-filter-prefix-selected-item', 'Travel Class')
          : null
      }
    />
  );

  const mobileLayout = (
    <Box {...containerStyle}>
      {showTitle ? (
        <Text
          variant="text.fontSize5"
          display="flex"
          alignItems="center"
          paddingLeft="5px"
          paddingBottom="15px"
          {...titleStyle}
        >
          {title}
        </Text>
      ) : null}
      <RadioButtonGroup
        options={travelClassOptions}
        defaultOption={travelClassValue}
        onChange={(newTravelClass) => {
          setTravelClass(newTravelClass);
          props.onChange({ value: newTravelClass });
        }}
        orientation={mobileOrientation}
        itemsStyle={itemsStyles}
        itemsContainerStyle={itemsContainerStyle}
      />
    </Box>
  );

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>{!isMobile ? desktopLayout : mobileLayout}</ThemeProvider>
    </EmotionCache>
  );
};

export default React.forwardRef(TravelClassFilter);
